import * as config from "../config"

export default {
  data() {
    return {
      // 抽奖中
      isLuckDrawing: false,
      currentAward: "",
      retryCountDown: 10,

      // 个人奖励领取中
      isReveivingIndividualTaskPresent: false,
      // 请求查询中
      isRequesting: false
    }
  },
  methods: {
    autoLuckDraw(lotteryInfo) {
      if (!lotteryInfo) {
        this.setToastMsg("请检查配置~")
        return
      }
      return new Promise(() => {
        if (this.isLuckDrawing) {
          this.setToastMsg("正在领取中~")
          return
        }
        this.reportUserAction({
          iformat: config.REPORT.CLICK.START_DRAW,
          resutInfo: lotteryInfo
        })
        this.isLuckDrawing = true
        this.setLoading(true)
        this.luckyDraw({ num: lotteryInfo.num, code_id: lotteryInfo?.qualification?.[0]?.code_id })
          .then(res => {
            this.setLoading(false)
            try {
              this.currentAward = res.luckdraw_info.luckydraw_result[0].luck_got_goods[0]
            } catch (error) {
              this.setToastMsg("哎呀，活动太火爆啦！请稍后再试~")
            }
            this.isLuckDrawing = false
          })
          .catch(res => {
            this.setLoading(false)
            let msg = `系统繁忙，请稍后再试！(${res.ret})`
            if (res && res.msg && res.err_code == "") {
              msg = res.msg
              this.setToastMsg(msg)
              this.isLuckDrawing = false
            } else {
              this.retryCountDown = 10
              msg = `哎呀，活动太火爆啦！<br>排队进入${this.retryCountDown}……`
              this.toastMsg = msg
              let queueTimer = setInterval(() => {
                this.retryCountDown--
                msg = `哎呀，活动太火爆啦！<br>排队进入${this.retryCountDown}……`
                this.toastMsg = msg
                if (this.retryCountDown == 0) {
                  this.isLuckDrawing = false
                  this.toastMsg = ""
                  clearInterval(queueTimer)
                }
              }, 1000)
            }

            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DRAW_ERROR,
              resultInfo: res
            })
          })
      })
    }
  }
}
